(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["siwl107-holiday-notice"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('siwl107-holiday-notice')) {
    customElements.define('siwl107-holiday-notice', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.key = `siwl107-holiday-${this.dataset.campaign}`;
        this.preview = this.dataset.designMode === 'true' && this.dataset.editorPreview === 'true';
        this.dismissed = false;
        this.cursor = document.getElementById('custom-gif-cursor');
        this.cursorMedia = matchMedia('(min-width: 769px) and (pointer: fine)');
        this.cursorAttributes = ['popover', 'aria-hidden'].map(name => [name, this.cursor?.getAttribute(name)]);
        this.syncCursor = () => {
          if (!this.dialog.open || !this.cursorMedia.matches || !this.cursor?.showPopover || !this.cursor.complete || !this.cursor.naturalWidth) {
            this.restoreCursor();
            return;
          }
          if (this.cursor.hasAttribute('data-notice-top-layer') && this.cursor.matches(':popover-open')) return;
          try {
            this.cursor.setAttribute('popover', 'manual');
            this.cursor.setAttribute('aria-hidden', 'true');
            this.cursor.setAttribute('data-notice-top-layer', '');
            this.cursor.showPopover();
          } catch (_) { this.restoreCursor(); }
        };
        this.cursorMedia.addEventListener('change', this.syncCursor, options);
        this.cursor?.addEventListener('load', this.syncCursor, options);
        this.querySelector('[data-notice-link]')?.addEventListener('click', () => this.dismiss(false), options);
        this.querySelectorAll('[data-notice-close]').forEach(button => button.addEventListener('click', () => this.dismiss(false), options));
        this.querySelector('[data-notice-today]').addEventListener('click', () => this.dismiss(true), options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.dismiss(false); }, options);
        this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dismiss(false); }, options);
        this.dialog.addEventListener('close', () => this.unlock(), options);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.schedule(); }, options);
        window.addEventListener('pageshow', () => this.schedule(), options);
        document.addEventListener('shopify:section:select', event => {
          if (event.target.contains(this) && this.preview) { this.dismissed = false; this.open(); }
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.target.contains(this) && this.preview) this.close();
        }, options);
        this.schedule();
      }
      activeAt(now = Date.now()) {
        const start = Date.parse(this.dataset.startAt);
        const end = Date.parse(this.dataset.endAt);
        return this.dataset.enabled === 'true' && Number.isFinite(start) && Number.isFinite(end) && end > start && now >= start && now < end;
      }
      isDismissed() {
        if (this.preview) return this.dismissed;
        if (this.dismissed) return true;
        try { if (sessionStorage.getItem(this.key) === 'closed') return true; } catch (_) {}
        try { if (Number(localStorage.getItem(this.key)) > Date.now()) return true; } catch (_) {}
        return false;
      }
      schedule() {
        clearTimeout(this.showTimer);
        clearTimeout(this.boundaryTimer);
        if (this.dataset.designMode === 'true') {
          if (this.preview && !this.isDismissed()) this.showTimer = setTimeout(() => this.open(), 300);
          else this.close();
          return;
        }
        const now = Date.now();
        const start = Date.parse(this.dataset.startAt);
        const end = Date.parse(this.dataset.endAt);
        if (this.activeAt(now)) {
          if (!this.isDismissed() && !this.dialog.open) this.showTimer = setTimeout(() => this.open(), Number(this.dataset.delay || 3) * 1000);
          this.boundaryTimer = setTimeout(() => this.schedule(), Math.min(end - now, 2147483647));
        } else {
          this.close();
          if (this.dataset.enabled === 'true' && Number.isFinite(start) && end > start && start > now) {
            this.boundaryTimer = setTimeout(() => this.schedule(), Math.min(start - now, 2147483647));
          }
        }
      }
      open() {
        if (!this.isConnected || this.dialog.open || this.isDismissed()) return;
        if (!this.preview && !this.activeAt()) return;
        if (document.querySelector('dialog[open]')) return;
        this.previousOverflow = document.body.style.overflow;
        this.dialog.showModal();
        document.body.style.overflow = 'hidden';
        this.locked = true;
        this.syncCursor();
      }
      restoreCursor() {
        if (!this.cursor?.hasAttribute('data-notice-top-layer')) return;
        try { if (this.cursor.matches(':popover-open')) this.cursor.hidePopover(); } catch (_) {}
        this.cursor.removeAttribute('data-notice-top-layer');
        this.cursorAttributes.forEach(([name, value]) => {
          if (value == null) this.cursor.removeAttribute(name);
          else this.cursor.setAttribute(name, value);
        });
      }
      unlock() {
        this.restoreCursor();
        if (!this.locked) return;
        document.body.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      close() {
        if (this.dialog?.open) this.dialog.close();
        this.unlock();
      }
      dismiss(today) {
        this.dismissed = true;
        if (!this.preview) {
          if (today) {
            const kstDay = new Date(Date.now() + 9 * 3600000).toISOString().slice(0, 10);
            const midnight = Date.parse(`${kstDay}T00:00:00+09:00`) + 86400000;
            try { localStorage.setItem(this.key, String(midnight)); } catch (_) {}
          } else {
            try { sessionStorage.setItem(this.key, 'closed'); } catch (_) {}
          }
        }
        this.close();
      }
      disconnectedCallback() {
        clearTimeout(this.showTimer);
        clearTimeout(this.boundaryTimer);
        this.controller?.abort();
        this.close();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
